export const objectToClassNames = object =>
  Object
    .entries(object)
    .filter(([, isEnabled]) => isEnabled)
    .map(([className]) => className)
    .join(' ')
